<template>
  <div class="form-group form-row">
    <label :for="safeId('folder')" class="col-sm-4 col-form-label">Folder</label>
    <div class="col-sm-8">
      <input type="text" class="form-control" :id="safeId('folder')" v-model.lazy="folder" list="folders"/>
    </div>
  </div>
</template>

<script>
  import * as action from '@/store/action-types'

  export default {
    name: 'template-setting-folder',
    props: {
      templateId: {
        type: String,
        required: true
      }
    },
    computed: {
      folder: {
        get: function () {
          return this.$store.getters.template(this.templateId).folder
        },
        set: function (val) {
          this.$store.dispatch(action.TEMPLATE_FOLDER, {
            templateId: this.templateId,
            folder: val
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/template-settings/template-setting-folder.vue